import { Close } from '@mui/icons-material';
import { Box, Theme, Typography, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@/components';
import { Modals, urls } from '@/constants';
import { AppModal } from '@/containers';
import { AnalyticsService, CPA_BUTTON_NAME } from '@/services';
import { selectSessionUserId, uiActions } from '@/store';
import { CPACanadaEpisode } from '@/types';

interface CPAContentEndModalProps {
  cpaCanadaContent?: CPACanadaEpisode | null;
}

export const CPAContentEndModal = ({
  cpaCanadaContent,
}: CPAContentEndModalProps) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  const isAnonymous = !useSelector(selectSessionUserId);

  const onCloseModal = () => {
    dispatch(uiActions.closeActiveModal());
  };

  if (!cpaCanadaContent) return null;

  return (
    <AppModal
      modalName={Modals.CPA_CONTENT_END}
      fullScreen={isMobile}
      disableBackdropClick={true}>
      <Box
        sx={{
          border: 1,
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          px: { xs: 2, md: 6 },
          py: 6,
        }}>
        <Button
          fullWidth={false}
          startIcon={<Close />}
          skinny={false}
          variant="tertiary"
          onClick={onCloseModal}
          sx={{ position: 'absolute', top: 4, left: 4 }}
          aria-label="Close modal"
        />
        <Box>
          <Typography variant="h3" mb={4}>
            {cpaCanadaContent.modalEpFinished.header}
          </Typography>
          <Typography variant="body1">
            {cpaCanadaContent.modalEpFinished.subHeader}
          </Typography>
          <Button
            label={cpaCanadaContent.modalEpFinished.ctaBtnText}
            skinny={false}
            sx={{ mt: 4, mb: 1 }}
            onClick={() => {
              AnalyticsService.buttonClick({
                name: CPA_BUTTON_NAME.CONTENT_END_MODAL,
              });
              window.open(
                urls.appBase + cpaCanadaContent.modalEpFinished.ctaLink,
                '_self',
              );
            }}
          />
          {isAnonymous && (
            <Box>
              <Typography variant="caption1">
                {cpaCanadaContent.modalEpFinished.footer}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </AppModal>
  );
};
